import {
  SET_DATA,
  QUESTION_FETCHING_INIT,
  QUESTION_FETCHING_COMPLETE,
  SET_FORM_DATA,
  SET_PAGE_BREAK,
} from "./types";
const initialState = {
  name: "",
  slug: "",
  questions: [],
  isDataLoading: false,
  submit_user_info_btn_disable: false,
  User_info_name: "",
  User_info_email: "",
  User_info_cc_name: "",
  User_info_cc_email: "",
  User_info_designation: "",
  User_info_content: "",
  User_info_subject: "",
  show_user_info_popup: false,
  answers: [],
  answers_entered: [],
  formated_ans: {},
  new_page: {},
  registrationData: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return { ...state, ...action.payload };
    case QUESTION_FETCHING_INIT:
      return { ...state, isDataLoading: true, ...action.payload };

    case QUESTION_FETCHING_COMPLETE: {
      return { ...state, isDataLoading: false, ...action.payload };
    }
    case SET_FORM_DATA: {
      return {
        ...state,
        formated_ans: {
          ...state.formated_ans,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case SET_PAGE_BREAK: {
      return {
        ...state,
        new_page: {
          ...state.new_page,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    default:
      return state;
  }
};
